import { memo } from 'react';

import RerunIconSVG from '@/assets/rerun-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IRerunIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={RerunIconSVG} {...props} />;

export const RerunIcon = memo(IRerunIcon) as typeof IRerunIcon;
